import { AttributesMixin, define, Model, type } from "@type-r/models";

@define
export class ComputedTargetField extends Model {
  static attributes = {
    id: Number,
    name: String
  };
}

export interface ComputedField extends AttributesMixin<typeof ComputedField> { }

@define
export class ComputedField extends Model {
  static attributes = {
    assetTypeId: Number,
    computedFieldItems: [type({
      field1: ComputedTargetField,
      field2: ComputedTargetField,
      operator: String,
      resultField: ComputedTargetField
    })]
  };
}
